import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { ICON_BUTTON_TEXT_CLASS, iconButton } from '@noths/polaris-client-styles';
import * as styles from "../styles/SimpleModalHeader.styles";
import { IconClose } from "../../../foundations/Iconography/IconClose";
var ICON_SIZE = 24;
export var SimpleModalHeader = function SimpleModalHeader(_ref) {
  var onClose = _ref.onClose,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(_StyledHeader, {
    $_css: styles.header
  }, /*#__PURE__*/React.createElement(_StyledH, {
    $_css2: styles.title
  }, title), onClose && /*#__PURE__*/React.createElement(_StyledButton, {
    onClick: onClose,
    $_css3: [iconButton, styles.closeBtn]
  }, /*#__PURE__*/React.createElement(IconClose, {
    height: ICON_SIZE,
    width: ICON_SIZE
  }), /*#__PURE__*/React.createElement("span", {
    className: ICON_BUTTON_TEXT_CLASS
  }, "Close")));
};
var _StyledHeader = _styled("header")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledH = _styled2("h3")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledButton = /*#__PURE__*/_styled3("button").withConfig({
  displayName: "SimpleModalHeader___StyledButton",
  componentId: "sc-r7psr2-0"
})(["", ""], function (p) {
  return p.$_css3;
});